import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { CONTACT } from '../data/products';

const marqueeItems = ['MISKY', 'Ceramide Complex 2%', 'Face & Body', 'Daily Skin Care', 'مسكي', 'عناية يومية مطمئنة', '150 ml', 'Jordan · Amman'];

export default function Footer() {
  const { t } = useLang();
  const f = t.footer;
  const doubled = [...marqueeItems, ...marqueeItems];

  return (
    <footer className="bg-misky-black text-white">
      {/* Scrolling marquee */}
      <div className="border-y border-white/10 py-4 overflow-hidden">
        <div className="marquee-inner flex items-center gap-12 whitespace-nowrap w-max">
          {doubled.map((item, i) => (
            <span key={i} className="text-sm font-medium tracking-widest uppercase text-misky-mid">
              {item}
            </span>
          ))}
        </div>
      </div>

      {/* Main footer row */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Brand */}
          <div>
            <div className="font-display text-2xl font-bold tracking-widest">MISKY</div>
            <div className="text-[10px] tracking-[0.25em] text-misky-mid uppercase mt-0.5">Ceramide Complex 2%</div>
          </div>

          {/* Center info */}
          <div className="text-center text-xs text-misky-mid space-y-1">
            <div>{f.rights}</div>
            <div>{f.location}</div>
          </div>

          {/* WhatsApp */}
          <a
            href={`https://wa.me/${CONTACT.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 bg-[#25D366]/15 border border-[#25D366]/30 text-[#25D366] px-4 py-2 rounded-full text-sm font-medium hover:bg-[#25D366]/25 transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            {f.orderWhatsapp}
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 py-4 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          {/* Exclusive product text */}
          <p className="text-xs text-misky-mid">{f.exclusive}</p>

          {/* Powered by */}
                  <p style={{ direction: 'ltr' }} className="text-xs text-misky-mid flex items-center gap-1.5 flex-shrink-0">
            {f.poweredBy}
            <a
              href="http://204.12.233.112/TariqPortfolio/"
              target="_blank"
              rel="noreferrer"
              className="text-white/70 hover:text-white underline underline-offset-4 transition-colors font-medium"
            >
              Tariq Alassadi
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
